import * as React from 'react';
import styled, { css } from 'styled-components';

type ButtonThemeType = 'primary' | 'secondary' | 'tertiary';
type ButtonColorTheme = 'gold' | 'gray';

type ButtonAsType = 'a' | 'link';

interface IButton {
  type?: ButtonThemeType;
  as?: ButtonAsType;
  to?: string;
  href?: string;
  center?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  colorTheme?: ButtonColorTheme;
  withIcon?: boolean;
  onClick?: (e: any) => void;
}

export const Button: React.FC<IButton> = ({
  type,
  as,
  to,
  href,
  center,
  children,
  fullWidth,
  disabled,
  loading,
  colorTheme,
  withIcon,
  onClick,
}) => {
  const buttonRef: any = React.useRef(null);
  if (type === 'tertiary') {
    return (
      <StyledTertiaryButton onClick={onClick} ref={buttonRef}>
        {children}
      </StyledTertiaryButton>
    );
  } else {
    return (
      <StyledButton
        as={as}
        href={href}
        themetype={type}
        colorTheme={colorTheme}
        fullwidth={fullWidth?.toString()}
        disabled={disabled}
        onClick={onClick}
        ref={buttonRef}
        center={center?.toString()}
      >
        {children}
      </StyledButton>
    );
  }
};

const BaseButton = css<any>`
  display: block;
  transition: color 0.15s ease-in-out, background 0.15s ease-in-out;
  padding: 0 15px;
  height: 3rem;
  font-size: 14px;
  border: none;
  outline: none;
  font-weight: 400;
  color: ${(props: any) => props.theme.buttons[props.themetype].color};
  ${(props: any) => (props.fullwidth === 'true' ? `width: 100%;` : '')}
  appearance: none;
  -webkit-appearance: none;
  user-select: none;
  text-decoration: none;

  &.nybygg {
    background: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
  }

  &:focus {
    outline: none;
  }

  span {
    width: 100%;
  }

  &:hover {
    cursor: pointer;
  }

  &.full-width {
    @media screen and (max-width: 800px) {
      width: 100%;
    }
  }
`;

const PrimaryButton = css<any>`
  line-height: 3rem;
  background: ${(props: any) =>
    props?.theme?.buttons[props.themetype]?.themes[props?.colorTheme]
      ?.background};
  color: ${(props) =>
    props?.theme?.buttons[props.themetype]?.themes[props?.colorTheme]?.color};
  border-radius: 0;

  ${({ center }) => {
    return center === 'true' ? 'text-align: center;' : '';
  }}
`;

const StyledButton: any = styled.button<any>`
  ${BaseButton}
  ${PrimaryButton}
`;

const StyledTertiaryButton = styled.button`
  padding: 0 15px;
  height: 3rem;
  font-size: 14px;
  border: none;
  outline: none;
  font-weight: 400;
  appearance: none;
  -webkit-appearance: none;
  user-select: none;
  text-decoration: none;

  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9375rem 0 0.625rem 0;
  background: none;
  color: #fff;
  border-bottom: solid 2px
    ${(props: any) => props?.theme?.buttons['tertiary']?.borderColor};

  &:hover {
    cursor: pointer;
  }
`;
